// PRC-048: de la decisión del panel a la escritura (diferida con «Deshacer»).
import {
  createMarginCenterFollowUp,
  openOrLinkMarginCenterCadenceFollowUpV2,
  resolveMarginCenterCadenceOccurrenceV2,
} from '../../services/marginCenterService';
import type { CadenceDecision, CadenceManagementTarget } from './CadenceManagementDrawer';
import { NOT_RELEVANT_CONCLUSION, NOT_RELEVANT_TYPE } from './cadenceManagementTexts';
import { cadenceRowKey, type CadenceListTab, type DeferredCadenceAction } from './useDeferredCadenceActions';

export function cadenceDecisionAction(
  target: CadenceManagementTarget,
  decision: CadenceDecision,
  from: CadenceListTab,
): DeferredCadenceAction {
  const key = cadenceRowKey(target.customer_id, target.product_id, target.first_outside_p90_date);
  const episode = target.first_outside_p90_date;
  const who = `${target.customer_label} · ${target.product_id}`;

  if (decision.kind === 'commercial') {
    if (!episode) {
      // Relación sin aviso activo: seguimiento manual (origen Manual por defecto).
      return {
        key, from, to: 'in_follow_up',
        message: `Seguimiento abierto: ${who}`,
        run: () => createMarginCenterFollowUp(target.customer_id, target.product_id, {
          opening_reason: decision.openingReason,
          next_action: decision.nextAction,
          next_review_at: decision.nextReviewIso,
        }),
      };
    }
    return {
      key, from, to: 'in_follow_up',
      message: decision.followUpId ? `Añadido al seguimiento existente: ${who}` : `Seguimiento abierto: ${who}`,
      run: () => openOrLinkMarginCenterCadenceFollowUpV2(target.customer_id, target.product_id, {
        first_outside_p90_date: episode,
        follow_up_id: decision.followUpId,
        opening_reason: decision.openingReason,
        next_action: decision.nextAction,
        next_review_at: decision.nextReviewIso,
      }),
    };
  }

  if (!episode) {
    throw new Error('Sin aviso activo solo se puede abrir un seguimiento.');
  }

  if (decision.kind === 'cause') {
    return {
      key, from, to: 'resolved',
      message: `Aviso archivado: ${who}`,
      run: () => resolveMarginCenterCadenceOccurrenceV2(target.customer_id, target.product_id, {
        first_outside_p90_date: episode,
        disposition: 'explained',
        resolution_type: decision.reason,
        conclusion: decision.conclusion,
        substitute_product_id: decision.substituteProductId,
      }),
    };
  }

  return {
    key, from, to: 'resolved',
    message: `Aviso descartado: ${who}`,
    run: () => resolveMarginCenterCadenceOccurrenceV2(target.customer_id, target.product_id, {
      first_outside_p90_date: episode,
      disposition: 'not_relevant',
      resolution_type: NOT_RELEVANT_TYPE,
      conclusion: decision.note ? `${NOT_RELEVANT_CONCLUSION}. ${decision.note}` : NOT_RELEVANT_CONCLUSION,
    }),
  };
}
